import { mapActions } from 'vuex'

export const inActiveSession = {
  data() {
    return {
      time: null
    }
  },

  methods: {
    ...mapActions('auth', { triggerLogout: 'logOut' }),

    resetTimer() {
      clearTimeout(this.time)
      if (this.$route.name !== 'auth-login') {
        this.time = setTimeout(this.logout, 1200000) // 20min
      }
    },
    logout() {
      clearTimeout(this.time)
      this.triggerLogout()
      document.removeEventListener('load', this.resetTimer)
      document.removeEventListener('mousemove', this.resetTimer)
      document.removeEventListener('keydown', this.resetTimer)
      this.$nextTick(() => {
        this.$router.push('/')
      })
    }
  },

  mounted() {
    document.addEventListener('load', this.resetTimer)
    document.addEventListener('mousemove', this.resetTimer)
    document.addEventListener('keydown', this.resetTimer)
  }
}
